import { render, staticRenderFns } from "./FamilyHistory.vue?vue&type=template&id=37378f96"
import script from "./FamilyHistory.vue?vue&type=script&lang=js"
export * from "./FamilyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports